import { loadModules } from 'esri-loader'

const state = () => ({  
  geometryService: null,
  showMeasreDialog: false,
  measureScalesList: null,
  measureOptions: [],
  measureOptionsSelect: {},
  measuredVals: null,
  tb_measure: null,
  currentTool: 'measure-length',
  mapClick: null
})

const mutations = {

  setCurrentTool: (state, payload) => {
    state.currentTool = payload
  },

  SET_GEOMETRY_SERVICE: (state, payload) => {
    state.geometryService = payload
  },

  SET_MEASURE_DIALOG: (state, payload) => {
    state.showMeasreDialog = payload
  },

  SET_MEASURE_ITEMS: (state, payload) => {
    state.measureScalesList = payload
  },

  SET_MEASURE_OPTIONS: (state, payload) => {
    state.measureOptions = payload
  },
  SET_MEASURE_SELECT: (state, payload) => {
    // console.log('reset measure option select')
    state.measureOptionsSelect = payload
    // console.log('MUTATION state.measureOptionsSelect == '+JSON.stringify(state.measureOptionsSelect))
  },
  SET_MEASURED_VALS: (state, payload) => {
    state.measuredVals = payload
  },

  SET_MEASURE_DRAW: (state, payload) => {
    state.tb_measure = payload
  },
  UNSET_MEASURE_DRAW: (state, payload) => {
    if (state.tb_measure) {
      state.tb_measure.deactivate()
    }
  }
}

const getters = {

  getGeometryService: state => {
    return state.geometryService
  },
  getMeasureDialog: state => {
    return state.showMeasreDialog
  },
  getMeaseureScaleList: state => {
    return state.measureScalesList
  },
  getMeasrureOptions: state => {
    return state.measureOptions
  },
  getMeasureSelect: state => {
    return state.measureOptionsSelect
  },
  getMeasuredVals: state => {
    return state.measuredVals
  },
  getMeasureDraw: state => {
    return state.tb_measure
  }

}

const actions = {
  activateMeasure: ({ state, commit, dispatch, rootState }, payload) => {
    const map = rootState.mapFunctions.stateMap
    dispatch('deactivateMeasureTB')
    let tool = ''

    loadModules(['esri/toolbars/draw', 'esri/symbols/PictureMarkerSymbol', 'dojo/_base/lang', 'esri/graphic']).then(([Draw, PictureMarkerSymbol, lang, Graphic]) => {
      commit('SET_MEASURE_DRAW', new Draw(map));
      //state.tb_measure = new Draw(map);
      //console.log("Tool before ::" + payload);
      switch (payload) {
        case "measure-location":
          tool = "point"
          break
        case "measure-length":
          tool = "polyline";
          // add custom green pin
          this.mapClick = map.on('click', lang.hitch(this, function (e) {
            var pictureMarkerSymbol = new PictureMarkerSymbol('https://js.arcgis.com/3.15/esri/dijit/images/esriGreenPin16x26.png', 16, 26);
            pictureMarkerSymbol.xoffset = 0
            pictureMarkerSymbol.yoffset = 12
            map.graphics.add(new Graphic(e.mapPoint, pictureMarkerSymbol))
          })
          )
          break
        case "measure-area":
          tool = "polygon";
          break
      }

      map.graphics.clear()
      map.disableMapNavigation()
      state.tb_measure.activate(tool)
      state.tb_measure.on("draw-complete", function (evt) {
        dispatch('drawComplete', evt)
      })
    })
  },

  drawComplete: ({ state, commit, dispatch, rootState }, payload) => {

    // const map = rootState.mapFunctions.stateMap
    let measureOptionsList = []
    if (payload.geometry.type == 'point') { //  If the drawn graphic is Point

      // feedback.addGraphic(payload) //  Display the graphic in the map using addGraphic function that is already written in feedback.js
      dispatch('addGraphic', payload)

      // measureOptionsList = [{ esriLatLong : 'Lat,Long' , esriStatePlane: 'State Plane'}]
      measureOptionsList = [{ val: 'esriLatLong', text: 'Lat,Long' }, { val: 'esriStatePlane', text: 'State Plane' }]
      commit('SET_MEASURE_OPTIONS', measureOptionsList)

      if (Object.keys(state.measureOptionsSelect).length === 0 && state.measureOptionsSelect.constructor === Object) {
        commit('SET_MEASURE_SELECT', { val: 'esriLatLong', text: 'Lat,Long' })
      }

      // dispatch('measure_point', [payload.geometry,'esri.9002'])          

      /*
      $('#measure_options').empty()
 
      //  Populate the drop-down in the measure with different units
      $.each(measureOptions, function(val, text) {
        $('#measure_options').append(new Option(text, val))
      })
      */
      // console.log('default unit....!')
      // $('#measure_options').val('Lat,Long') //  Default unit that shows up first when the measure for point is complete

      // $('#measure_options').attr('selectedIndex', 0)
      // $('#measure_options').selectmenu('refresh')
      //  Display the measurement values and offset the pop-up by a distance, so that they don't overlap with the drawn graphic
      // console.log('contents to be displayed...::'+'X: '+dojo.number.format(payload.geometry.getLongitude()) + '<br/> Y: '+ dojo.number.format(payload.geometry.getLatitude())+'<br/>')
      commit('SET_MEASURED_VALS', 'X: ' + dojo.number.format(payload.geometry.getLongitude()) + '    ,        Y: ' + dojo.number.format(payload.geometry.getLatitude()))
      commit('SET_MEASURE_DIALOG', true)
      // $('#popup-content').html('X: '+dojo.number.format(payload.geometry.getLongitude()) + '<br/> Y: '+ dojo.number.format(evt.geometry.getLatitude())+'<br/>')
      // $( '#measure-popup' ).popup( 'open', {x:screenExtent.x+20,y:screenExtent.y-10} )

      // document.getElementById('popup-content').html('X: '+dojo.number.format(payload.geometry.getLongitude()) + '<br/> Y: '+ dojo.number.format(evt.geometry.getLatitude())+'<br/>')
      // document.getElementById('measure-popup').popup( 'open', {x:screenExtent.x+20,y:screenExtent.y-10} )
    } else if (payload.geometry.type == 'polyline') { //  If the drawn graphic is Polyline
      //console.log('Add graphic start...')
      //  Display the graphic in the map using addGraphic function
      dispatch('addGraphic', payload)
      // console.log('Add graphic end...')

      // http://resources.esri.com/help/9.3/ArcGISDesktop/ArcObjects/esriGeometry/esriSRUnitType.htm*/
      const measureOptionsList = [{ val: 'esri.9030', text: 'Miles' }, { val: 'esri.9002', text: 'Feet' }, { val: 'esri.9036', text: 'Km' }, { val: 'esri.9001', text: 'Meter' }]
      commit('SET_MEASURE_OPTIONS', measureOptionsList)
      // console.log('SET FEET')
      //  if state.measureOptionsSelect is empty then set its value.
      if (Object.keys(state.measureOptionsSelect).length === 0 && state.measureOptionsSelect.constructor === Object) {
        commit('SET_MEASURE_SELECT', { val: 'esri.9002', text: 'Feet' })
      }
      dispatch('measure_length', [payload.geometry, 'esri.9002'])
    } else if (payload.geometry.type == 'polygon') { //  If the drawn graphic is Polygon
      //  Display the graphic in the map using addGraphic function
      dispatch('addGraphic', payload)

      // http://resources.arcgis.com/en/help/arcobjects-net/componenthelp/index.html#// 004200000015000000*/
      const measureOptionsList = [{ val: 'esriAcres', text: 'Acres' }, { val: 'esriHectares', text: 'Hectares' }, { val: 'esriSquareFeet', text: 'Sq. Feet' }, { val: 'esriSquareKilometers', text: 'Sq. Km' }, { val: 'esriSquareMeters', text: 'Sq. Meters' }, { val: 'esriSquareMiles', text: 'Sq. Miles' }]
      commit('SET_MEASURE_OPTIONS', measureOptionsList)

      // console.log('state.measureOptionsSelect==' + state.measureOptionsSelect + ' --- ' + state.measureOptionsSelect.constructor)
      // console.log(JSON.stringify(state.measureOptionsSelect))

      if (Object.keys(state.measureOptionsSelect).length === 0 && state.measureOptionsSelect.constructor === Object) {
        // console.log('empty ---- ')
        commit('SET_MEASURE_SELECT', { val: 'esriSquareFeet', text: 'Sq. Feet' })
        // console.log('state.measureOptionsSelect ==' + JSON.stringify(state.measureOptionsSelect))
      }
      //  Measure Length
      dispatch('measure_area', [payload.geometry, 'esriSquareFeet'])
    }

    //  Deactivate the measure tool and activate the map onClick events (to show Pop-ups)

    // tb_measure.deactivate() //  Uncomment and set in store

    // if (mapOnClickHandler == null) {
    //     reenableClickActions()
    // }
  },

  //  Function to draw graphics on the map - Feedback tool + Measure tool
  addGraphic: ({ state, dispatch, commit, rootState }, evt) => {
    const map = rootState.mapFunctions.stateMap
    loadModules(['esri/symbols/SimpleLineSymbol',
      'esri/symbols/SimpleFillSymbol',
      'esri/symbols/SimpleMarkerSymbol',
      'esri/symbols/PictureMarkerSymbol',
      'esri/geometry/screenUtils',
      'esri/graphic',
      'esri/graphicsUtils',
      'esri/Color']).then(([SimpleLineSymbol, SimpleFillSymbol, SimpleMarkerSymbol, PictureMarkerSymbol, screenUtils, Graphic, graphicsUtils, Color]) => {

      // console.log('Add Graphics')

      // commit('SET_ADDED_GRAPHICS', evt)

      //  markerSymbol is used for point and multipoint, see http:// raphaeljs.com/icons/#talkq for more examples
      let markerPath, symbol
      var pictureMarkerSymbol = new PictureMarkerSymbol('https://js.arcgis.com/3.15/esri/dijit/images/esriGreenPin16x26.png', 16, 26)

      //  Override the default symbology -- This color code is for features drawn using Feedback/Meausre draw tools    
      var simpleLineSymbol = new SimpleLineSymbol(SimpleLineSymbol.STYLE_DASH, new Color([109, 26, 144]), 4)
      simpleLineSymbol.marker = pictureMarkerSymbol
      pictureMarkerSymbol.yoffset = 12
      var simpleFillSymbol = new SimpleFillSymbol(SimpleFillSymbol.STYLE_SOLID, new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([223, 161, 255]), 2), new Color([232, 190, 254, 0.6]))
      // console.log('in the add graphics: ' + evt.geometry.type)
      //  For point symbols, SVG markers are created based on the tool
      //  How to create SVG Paths: https:// developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths    
      if (evt.geometry.type === 'point') {
      // if (measureOpen) { //  If measure is active tool, the point symbol should be Crosshair
      // markerPath = 'M230 80 A 70 70, 0, 1, 1, 229.9 80 z l0,140 M300,150 L160,150'
        markerPath = 'M24 11h-2.051c-.469-4.725-4.224-8.48-8.949-8.95v-2.05h-2v2.05c-4.725.47-8.48 4.225-8.949 8.95h-2.051v2h2.051c.469 4.725 4.224 8.48 8.949 8.95v2.05h2v-2.05c4.725-.469 8.48-4.225 8.949-8.95h2.051v-2zm-11 8.931v-3.931h-2v3.931c-3.611-.454-6.478-3.32-6.931-6.931h3.931v-2h-3.931c.453-3.611 3.32-6.477 6.931-6.931v3.931h2v-3.931c3.611.454 6.478 3.319 6.931 6.931h-3.931v2h3.931c-.453 3.611-3.32 6.477-6.931 6.931zm1-7.931c0 1.104-.896 2-2 2s-2-.896-2-2 .896-2 2-2 2 .896 2 2z'

        var markerSymbol = new SimpleMarkerSymbol()
        // markerSymbol.setPath('M12 4c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm0-2c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10zm0 6c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm0-2c-3.314 0-6 2.686-6 6s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6zm0 4c-1.105 0-2 .896-2 2s.895 2 2 2 2-.896 2-2-.895-2-2-2z')
        markerSymbol.setPath(markerPath)
        markerSymbol.setColor(new Color([109, 26, 144]))
        markerSymbol.setSize(20)
        markerSymbol.setOutline(new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([109, 26, 144])).setWidth(1))

        symbol = pictureMarkerSymbol
        // symbol = createSymbol(markerPath, [109, 26, 144], 10, '20')
        /*
        } else { //  If feedback is active tool, the point symbol should be Bulls-eye                  
            // markerPath = 'M230 80 A 10 10, 0, 1, 0, 229 80 Z M230 75 A 5 5, 0, 1, 0, 229 75 Z M230 70 A 0 0, 0, 1, 0, 229 70 Z'
            markerPath = 'M64 0c-35.311 0-64 28.689-64 64s28.689 64 64 64 64-28.689 64-64-28.689-64-64-64zm0 6c32.068 0 58 25.932 58 58s-25.932 58-58 58-58-25.932-58-58 25.932-58 58-58zm0 20c-20.951 0-38 17.049-38 38s17.049 38 38 38 38-17.049 38-38-17.049-38-38-38zm0 6c17.709 0 32 14.291 32 32s-14.291 32-32 32-32-14.291-32-32 14.291-32 32-32zm0 20c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12z'
            // symbol = createSymbol(markerPath, null, 1.5)                  
            // symbol = createSymbol(markerPath, [109, 26, 144], 1.5, '32')
        } */
      } else if (evt.geometry.type === 'polyline') {
        symbol = simpleLineSymbol
        symbol.marker = markerSymbol
      } else if (evt.geometry.type === 'polygon' || evt.geometry.type === 'extent') {
        symbol = simpleFillSymbol
      }

      var sketchGraphics = map.getLayer('sketchGraphics')
      // console.log('sketchGraphics')
      // console.log(sketchGraphics)
      //  Add these graphics to the map once the symbology is assigned to it.
      sketchGraphics.add(new Graphic(evt.geometry, symbol))

      if (evt.geometry.type === 'point') {
        var screenExtent;
        // console.log('graphics type is point')
        screenExtent = new screenUtils.toScreenGeometry(map.extent, map.width, map.height, sketchGraphics.graphics[0].geometry) //  To be used for Measure pop-ups
      } else {
        screenExtent = new screenUtils.toScreenGeometry(map.extent, map.width, map.height, graphicsUtils.graphicsExtent(sketchGraphics.graphics)) //  To be used for Measure pop-ups
      }

      //console.log('disable map action..')
      map.disableMapNavigation()
    })
  }, // End of function addGraphic

  //  Function to draw graphics on the map - Feedback tool + Measure tool
  clearGraphics: ({ state, dispatch, rootState }, evt) => {
    const map = rootState.mapFunctions.stateMap
    loadModules([]).then(([]) => {
      console.log('Add Graphics')
      var sketchGraphics = map.getLayer('sketchGraphics')
      //  Add these graphics to the map once the symbology is assigned to it.
      sketchGraphics.clear()
    })
  },
  //  This function is to create a simplemarkersymbol from SVG 
  // http:// forums.arcgis.com/threads/91383-How-to-apply-CSS-effects-to-custom-graphics-layer?highlight=SVG
  // https:// code.google.com/p/sputniktests/source/browse/trunk/app/dynamic/bullseye.svg?r=88

  createSymbol: function (path, color, outlineWidth, size) {
    /*
     markerPath = 'M230 80 A 70 70, 0, 1, 1, 229.9 80 z l0,140 M300,150 L160,150'
     symbol = createSymbol(markerPath, 'white', 10)
    */
    // console.log('in the create symbol')
    var markerSymbol = new SimpleMarkerSymbol()
    // markerSymbol.setPath('M12 4c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm0-2c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10zm0 6c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm0-2c-3.314 0-6 2.686-6 6s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6zm0 4c-1.105 0-2 .896-2 2s.895 2 2 2 2-.896 2-2-.895-2-2-2z')
    markerSymbol.setPath(path)
    markerSymbol.setColor(new Color(color))
    markerSymbol.setSize(size)
    markerSymbol.setOutline(new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([109, 26, 144])).setWidth(1))
    return markerSymbol
  },

  measure_length: ({ state, dispatch, rootState }, [geometry, unit]) => {
    // console.log('in the measure Length ' + geometry.type + ', ' + unit)
    // geometry,unit

    loadModules([
      'esri/tasks/LengthsParameters']).then(([LengthsParameters]) => {
      // console.log('Geometry :: '+geometry+', unit::'+unit)
      // console.log(JSON.stringify(geometry))
      // console.log(JSON.stringify(unit))                  

      var lengthParams = new LengthsParameters()
      lengthParams.polylines = [geometry]
      lengthParams.lengthUnit = unit.substring(5, unit.length)
      lengthParams.geodesic = true
      state.geometryService.lengths(lengthParams, function (results) {
        dispatch('measure_output', results)
      }) //  Using Geometry service to find the length of line feature. Once the measure is complete, call measure_output function
    })
  },
  //  Function to measure the area of polygon geometries
  measure_area: ({ state, dispatch, rootState }, [geometry, unit]) => {

    loadModules(['esri/tasks/AreasAndLengthsParameters', 'esri/tasks/GeometryService'])
      .then(([AreasAndLengthsParameters, GeometryService]) => {
        // console.log('in the measure Area :' + geometry.type + ', ' + unit)
        //  Simplify the geometries before calculating the area of the polygon. Unit is specified when being called in the code. 
        let areasAndLengthParams = new AreasAndLengthsParameters()
        areasAndLengthParams.lengthUnit = GeometryService.UNIT_FOOT
        // console.log('1. in the measure Area :' + geometry.type + ', ' + unit)
        areasAndLengthParams.areaUnit = unit
        areasAndLengthParams.calculationType = 'preserveShape'
        state.geometryService.simplify([geometry], function (simplifiedGeometries) {
          areasAndLengthParams.polygons = simplifiedGeometries
          state.geometryService.areasAndLengths(areasAndLengthParams, function (results) {
            console.log('1. state.measureOptionsSelect ==' + JSON.stringify(state.measureOptionsSelect))
            dispatch('measure_output', results)
          }) //  Once the measure is complete, call the measure_output function
        })
      })
  },

  measure_point: ({ state, commit }, [geometry, unit]) => {

    //  Function called when the units of measure changed for point features (when users chose different units than what shows up by default)
    // function measure_point(geometry,unit) {
    loadModules(['esri/tasks/ProjectParameters'])
      .then(([ProjectParameters]) => {
        var projectParams = new ProjectParameters()
        projectParams.geometries = [geometry]

        if (unit == 'esriLatLong') {
        // $('#popup-content').html('X: '+dojo.number.format(geometry.getLongitude()) + '<br/> Y: '+ dojo.number.format(geometry.getLatitude())+'<br/>')                
          commit('SET_MEASURED_VALS', 'X: ' + dojo.number.format(geometry.getLongitude()) + ', Y: ' + dojo.number.format(geometry.getLatitude()))
        }
        else if (unit === 'esriStatePlane') {
        // https://developers.arcgis.com/en/javascript/jshelp/pcs.html*/
          projectParams.outSR = new esri.SpatialReference(2223)
          state.geometryService.project(projectParams, function (result) {
          //  console.log('Point SP output ::'+JSON.stringify(result))
            commit('SET_MEASURED_VALS', 'X: ' + dojo.number.format(result[0].x) + ', Y: ' + dojo.number.format(result[0].y))
          })
        }

        //  commit('SET_MEASURED_VALS','X: '+dojo.number.format(payload.geometry.getLongitude())  + ', Y: '+ dojo.number.format(payload.geometry.getLatitude()))
        commit('SET_MEASURE_DIALOG', true)
      })
  },
  measure_output: ({ state, commit }, payload) => {
    let measureUnit = state.measureOptionsSelect.text
    //  console.log('measureUnit::'+measureUnit +' - '+payload.lengths[0].toFixed(1))

    if (measureUnit == 'Feet' || measureUnit == 'Meter') {
      commit('SET_MEASURED_VALS', payload.lengths[0].toFixed(1))
      //  $('#popup-content').html('Length: '+result.lengths[0].toFixed(1) + ' ')
    } else {
      commit('SET_MEASURED_VALS', payload.lengths[0].toFixed(2))
      //  $('#popup-content').html('Length: '+result.lengths[0].toFixed(2) + ' ')
    }

    //  Limit Sq. Feet and Sq. Meters area values to 1 decimal places, rest of the units with 2 decimal places
    if (payload.areas) {
      if (measureUnit === 'Sq. Feet' || measureUnit === 'Sq. Meters') {
        commit('SET_MEASURED_VALS', payload.areas[0].toFixed(1))
        //  $('#popup-content').html('Area: '+result.areas[0].toFixed(1) + ' ')
      } else {
        commit('SET_MEASURED_VALS', payload.areas[0].toFixed(2))
        //  $('#popup-content').html('Area: '+result.areas[0].toFixed(2) + ' ')
      }
    }

    commit('SET_MEASURE_DIALOG', true)
    /**/
  },

  //  Whenever the unit of the measure output is changed (in the jQuery Mobile Pop-up), this function is called
  measureChange: ({ state, dispatch, rootState }, payload) => {
    //  console.log('graphics added:: ')
    const map = rootState.mapFunctions.stateMap
    //  console.log(state.addedGraphics)

    //  console.log(JSON.stringify(payload))
    let unit = payload.val
    let sketchGraphics = map.getLayer('sketchGraphics')
    let lastGraphics = sketchGraphics.graphics.length - 1
    let geometry = sketchGraphics.graphics[lastGraphics].geometry

    //  console.log(geometry)
    if (geometry.type === 'polyline') {
      //  measure_length(geometry,unit)
      dispatch('measure_length', [geometry, unit])
    } else if (geometry.type === 'polygon') {
      dispatch('measure_area', [geometry, unit])
    } else if (geometry.type === 'point') {
      //  measure_point(geometry,unit)
      dispatch('measure_point', [geometry, unit])
    }

    /*
    $('#measure_options option:selected').each(function () {

      var unit = $(this).val()
      // console.log('Total Graphics Count:' + sketchGraphics.graphics.length)
      lastGraphics = sketchGraphics.graphics.length - 1
      var geometry = sketchGraphics.graphics[lastGraphics].geometry
      // console.log('changed...!' + ',' + unit + ',' + geometry.type)
      // console.log(geometry.type)
      //  Depending on the geometry type, call the corresponding function to re-calculate the graphic measurements
      if (geometry.type=='polyline'){
        measure_length(geometry,unit)
      }else if (geometry.type=='polygon'){
        measure_area(geometry,unit)
      }else if (geometry.type=='point'){
        measure_point(geometry,unit)
      }

 })
 */
  },

  deactivateMeasureTB: ({ state, commit, rootState }) => {
    var map = rootState.mapFunctions.stateMap
    if (this.mapClick) {
      this.mapClick.remove()
    }
    var sketchGraphics = map.getLayer('sketchGraphics')
    // console.log('sketchGraphics')
    // console.log(sketchGraphics)
    //  Add these graphics to the map once the symbology is assigned to it.
    sketchGraphics.clear()
    // console.log('Deactivate Tools ')
    commit('UNSET_MEASURE_DRAW')
    if (state.tb_measure) {
      state.tb_measure.deactivate()
    }

    map.enableMapNavigation()
  }

}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/measurement.js